import { BookOpen } from 'lucide-react';
import { Button } from '../ui/button';

export const DataNotFoundSection = ({
    title,
    icon,
    isFiltered = false,
    onResetFilters,
    dashboard = false,
}) => {
    if (isFiltered) {
        return (
            <div className="w-full h-55 flex flex-col justify-center items-center">
                {icon ? icon : <BookOpen className="text-primary mb-4 w-12 h-12" />}
                <h5 className="">{title}</h5>
                <p className=" my-2">No items currently fit your criteria</p>
                <Button variant={'destructive'} onClick={onResetFilters}>
                    Reset Filters
                </Button>
            </div>
        );
    }
    return (
        <div
            className={`w-full h-37.5 flex flex-col justify-center items-center ${
                dashboard ? 'bg-neutral-100 rounded-2xl' : ''
            }`}
        >
            {icon ? icon : <BookOpen className="text-primary mb-4 w-12 h-12" />}
            <h5 className="">{title}</h5>
        </div>
    );
};
